import React from 'react';

import styles from './MovieCardSkeleton.module.css';
import { MovieCardContentActionsSkeleton } from './_MovieCardContentActionsSkeleton';

export const MovieCardSkeleton = () => (
    <div className={styles.root}>
        <div className={styles.poster}>
            <div className={styles.overlay} />
        </div>
        <div className={styles.content}>
            <div className={styles.logo} />
            <div className={styles.meta} />
            <div className={styles.features} />
            <div className={styles.description} />
        </div>
        <div className={styles.actions}>
            <MovieCardContentActionsSkeleton />
        </div>
    </div>
);
